export default "__VITE_ASSET__8ns6vR3j__"